/* Medallied: book search and multi-select filters, run in the browser from a compact book list */
(function(){
  var FORMATS=['Atlas','Exam Prep and revision','Question Banks and MCQs','Handbooks'];
  var ALIAS={pg:'post graduation',obg:'obstetrics',obgyn:'obstetrics',paeds:'pediatric',peds:'pediatric',qbank:'question bank',mcqs:'mcq'};

  // ---------- data ----------
  function norm(s){return (s||'').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/&/g,' and ').replace(/ae/g,'e').replace(/oe/g,'e').replace(/[^a-z0-9]+/g,' ').trim()}
  function digits(s){return (s||'').toString().replace(/[^0-9xX]/g,'').toLowerCase()}
  function item(r){
    var tags=(r[10]||'').split('|').filter(Boolean),it={
      h:r[0],t:r[1],a:r[2]||'',isbn:digits(r[3]),v:r[4]||'',img:r[5]||'',p:r[6],c:r[7]||0,av:!!r[8],vid:r[9],tags:tags,yr:r[11]||0,ed:r[12]||'',cr:r[13]||0,w:r[14]||0,
      subs:[],subj:[],cats:[]};
    tags.forEach(function(t){var i=t.indexOf(':');if(i<0)return;var k=t.slice(0,i),val=t.slice(i+1);
      if(k==='sub')it.subs.push(val);else if(k==='subject')it.subj.push(val);else if(k==='cat')it.cats.push(val)});
    it.fmt=it.cats.filter(function(c){return FORMATS.indexOf(c)>-1});
    it.nt=norm(it.t);it.na=norm(it.a);it.nv=norm(it.v);
    it.nx=norm(it.cats.concat(it.subs,it.subj).join(' ')+' '+it.ed+' '+(it.yr||''));
    return it;
  }
  var mem={};
  function load(url,store){
    if(mem[url])return mem[url];
    var key='mbx2:'+url,S=store==='local'?window.localStorage:window.sessionStorage;
    try{var c=JSON.parse(S.getItem(key)||'null');if(c&&Date.now()-c.at<30*60*1000){return mem[url]=Promise.resolve(c.rows.map(item))}}catch(e){}
    var sep=url.indexOf('?')>-1?'&':'?';
    function page(n){return fetch(url+sep+'view=mbindex&page='+n,{credentials:'same-origin'}).then(function(r){if(!r.ok)throw 0;return r.text()}).then(function(t){return JSON.parse(t)})}
    mem[url]=page(1).then(function(first){
      var rest=[];for(var n=2;n<=first.pages;n++)rest.push(page(n));
      return Promise.all(rest).then(function(more){
        var rows=first.items;more.forEach(function(m){rows=rows.concat(m.items)});
        try{S.setItem(key,JSON.stringify({at:Date.now(),rows:rows}))}catch(e){}
        return rows.map(item);
      });
    });
    mem[url].catch(function(){delete mem[url]});
    return mem[url];
  }

  // ---------- matching ----------
  function terms(q){return norm(q).split(' ').filter(Boolean).map(function(w){return ALIAS[w]||w}).join(' ').split(' ')}
  function search(items,q){
    var ts=terms(q),qd=digits(q),isIsbnish=qd.length>=4&&qd.length>=q.replace(/[\s-]/g,'').length-1;
    if(!ts.length&&!isIsbnish)return [];
    function score(it,any){
      var s=0,hit=0;
      if(isIsbnish&&it.isbn.indexOf(qd)>-1){s+=it.isbn===qd?200:120;hit=ts.length}
      else ts.forEach(function(w){
        var d=/^[0-9x]+$/.test(w),got=0;
        if(it.nt.indexOf(w)>-1){got=1;s+=10;if((' '+it.nt).indexOf(' '+w)>-1)s+=5}
        if(it.na.indexOf(w)>-1){got=1;s+=7}
        if(it.nv.indexOf(w)>-1){got=1;s+=3}
        if(it.nx.indexOf(w)>-1){got=1;s+=4}
        if(d&&w.length>=3&&it.isbn.indexOf(w)>-1){got=1;s+=12}
        hit+=got;
      });
      if(any?hit===0:hit<ts.length)return null;
      if(it.nt.indexOf(norm(q))===0)s+=20;
      return {s:s+(it.av?1:0),hit:hit};
    }
    function run(any){var out=[],best=0;items.forEach(function(it){var r=score(it,any);if(r){out.push({it:it,s:r.s,hit:r.hit});if(r.hit>best)best=r.hit}});if(any)out=out.filter(function(o){return o.hit===best});out.sort(function(a,b){return b.s-a.s});return out.map(function(o){return o.it})}
    var r=run(false);r.loose=false;
    if(!r.length&&ts.length>1){r=run(true);r.loose=true}
    return r;
  }

  // ---------- card ----------
  function esc(t){return (t==null?'':String(t)).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function money(p){return '₹'+(p/100).toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}
  var heart='';
  function card(it){
    if(!heart){var tp=document.getElementById('mb-heart-tpl');heart=tp?tp.innerHTML:'♡'}
    var badge='',bc='';
    if(it.tags.indexOf('shelf:New Arrival')>-1){badge='New';bc=' mb-badge--p'}else if(it.cats.indexOf('Evergreens')>-1){badge='Evergreen'}else if(it.cats.indexOf('Atlas')>-1){badge='Atlas';bc=' mb-badge--p'}
    var off=it.c>it.p?Math.floor((it.c-it.p)*100/it.c):0,url='/products/'+it.h;
    return '<article class="mb-card"><div class="mb-card__img"><a href="'+url+'" tabindex="-1" aria-hidden="true">'+
      (it.img?'<img src="'+esc(it.img)+'" alt="'+esc(it.t)+'" loading="lazy" width="240">':'<span class="mb-card__noimg">'+esc(it.t.slice(0,60))+'</span>')+'</a>'+
      (badge?'<span class="mb-badge'+bc+'">'+badge+'</span>':'')+
      '<button type="button" class="mb-heart" data-wish="'+esc(it.h)+'" aria-pressed="false" aria-label="Save '+esc(it.t)+' to wishlist">'+heart+'</button></div>'+
      '<a class="mb-card__title" href="'+url+'">'+esc(it.t)+'</a>'+(it.a?'<span class="mb-card__meta">'+esc(it.a)+'</span>':'')+
      '<div class="mb-price"><b>'+money(it.p)+'</b>'+(off?'<s>'+money(it.c)+'</s><em>'+off+'% off</em>':'')+'</div>'+
      '<form method="post" action="/cart/add" data-mb-add><input type="hidden" name="id" value="'+it.vid+'"><input type="hidden" name="quantity" value="1">'+
      (it.av?'<button type="submit" class="mb-add">Add to cart</button>':'<button type="submit" class="mb-add" disabled>Sold out</button>')+'</form></article>';
  }
  window.mbCard=card;
  window.mbLoad=load;
  window.mbMoney=money;

  // ---------- filter + list engine ----------
  var GROUPS=[
    {k:'yt',label:'Year or type',get:function(it){return it.subs}},
    {k:'sub',label:'Subject',get:function(it){return it.subj}},
    {k:'pub',label:'Publisher',get:function(it){return it.v?[it.v]:[]}},
    {k:'yr',label:'Publishing year',get:function(it){return it.yr?[String(it.yr)]:[]},order:'desc'},
    {k:'fmt',label:'Format',get:function(it){return it.fmt}}
  ];
  var SHOW=6,STEP=24;
  // "Can't find this book" card for a search with no results; posts the same contact form as the book finder
  function noFind(q,wa){
    var isbn=/^[\d\-\s]{10,17}[xX]?$/.test(q)&&q.replace(/\D/g,'').length>=10;
    var head=isbn?'No book with ISBN '+esc(q)+' on our shelves yet':'We couldn’t find “'+esc(q)+'”';
    var tip=isbn?'We may still get it. Send us the request and we’ll check with the publisher.':'Check the spelling, or try the author’s name or the ISBN. Still nothing? We’ll find it for you.';
    var msg=encodeURIComponent('Hi Medallied, I am looking for this book: '+q);
    return '<div class="mb-finder mb-nofind" style="grid-column:1/-1">'+
      '<div class="mb-finder__l"><span class="mb-eyebrow">Book finder</span><h2>'+head+'</h2><p>'+tip+'</p>'+
      '<div class="mb-steps"><div><i>1</i><span>Tell us the book, or send a photo of the cover</span></div><div><i>2</i><span>We check our shelves, then the publisher</span></div><div><i>3</i><span>You get a price on WhatsApp</span></div></div>'+
      (wa?'<a class="mb-btn mb-btn--line mb-nofind__wa" href="https://wa.me/'+esc(wa)+'?text='+msg+'" target="_blank" rel="noopener">WhatsApp us instead</a>':'')+'</div>'+
      '<form class="mb-form" method="post" action="/contact#find" accept-charset="UTF-8" data-finder>'+
      '<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">'+
      '<input type="hidden" name="contact[Request]" value="Book finder (no search results)">'+
      '<div class="mb-field full"><label for="nf-t">Book title or ISBN</label><input id="nf-t" name="contact[Book title]" value="'+esc(q)+'" required></div>'+
      '<div class="mb-field"><label for="nf-n">Your name</label><input id="nf-n" name="contact[name]" autocomplete="name" required></div>'+
      '<div class="mb-field"><label for="nf-p">WhatsApp number</label><input id="nf-p" name="contact[phone]" type="tel" placeholder="+91" autocomplete="tel" required></div>'+
      '<div class="mb-field full"><label for="nf-e">Email</label><input id="nf-e" name="contact[email]" type="email" autocomplete="email" required></div>'+
      '<div class="mb-field"><label for="nf-a">Author</label><input id="nf-a" name="contact[Author]" placeholder="Optional"></div>'+
      '<div class="mb-field"><label for="nf-y">Edition or year</label><input id="nf-y" name="contact[Edition]" placeholder="Optional"></div>'+
      '<button type="submit" class="mb-btn full">Find it for me</button></form></div>'+
      '<div class="mb-nofind__pop" style="grid-column:1/-1" data-nf-pop hidden><h3>Popular right now</h3><div class="mb-grid" data-nf-popgrid></div></div>';
  }
  // fill the "Popular right now" shelf under the finder card
  function fillPop(grid){
    var box=grid.querySelector('[data-nf-pop]');if(!box)return;
    load('/collections/best-sellers','session').then(function(items){
      var g=box.querySelector('[data-nf-popgrid]');g.innerHTML=items.filter(function(i){return i.av}).slice(0,8).map(card).join('');
      box.hidden=!g.children.length;if(window.mbPaintWish)window.mbPaintWish(g);
    }).catch(function(){});
  }

  function List(root,items,opt){
    var self=this;this.root=root;this.all=items;this.opt=opt||{};
    this.sel={};GROUPS.forEach(function(g){self.sel[g.k]=[]});
    this.open={};this.shown=STEP;this.sort=this.opt.relevance?'relevance':'best-selling';
    var u=new URL(location.href);
    GROUPS.forEach(function(g){var v=u.searchParams.getAll(g.k);if(v.length)self.sel[g.k]=v});
    var sb=u.searchParams.get('sort_by');if(sb)this.sort=sb;
    this.facets=root.querySelector('[data-mb-facets]');
    this.grid=root.querySelector('[data-mb-grid]');
    if(!this.grid){var g=document.createElement('div');g.className='mb-grid';g.setAttribute('data-mb-grid','');var res=root.querySelector('.mb-results')||root,emp=res.querySelector('.mb-empty');if(emp)emp.parentNode.replaceChild(g,emp);else res.appendChild(g);this.grid=g}
    this.count=root.querySelectorAll('[data-mb-count]');
    this.chips=root.querySelector('[data-mb-chips]');
    this.more=root.querySelector('[data-mb-more]');
    this.clear=root.querySelectorAll('[data-mb-clear]');
    root.querySelectorAll('.mb-pages').forEach(function(p){p.hidden=true});
    var sortSel=root.querySelector('[data-sort]');
    if(sortSel){
      if(this.opt.relevance&&!sortSel.querySelector('option[value=relevance]')){var o=document.createElement('option');o.value='relevance';o.textContent='Most relevant';sortSel.insertBefore(o,sortSel.firstChild)}
      if(!sortSel.querySelector('option[value=year-descending]')){var y=document.createElement('option');y.value='year-descending';y.textContent='Publishing year, newest';sortSel.appendChild(y)}
      sortSel.value=this.sort;sortSel.setAttribute('data-mb-live','1');
      sortSel.addEventListener('change',function(){self.sort=sortSel.value;self.shown=STEP;self.render(true)});
    }
    if(this.more)this.more.addEventListener('click',function(){self.shown+=STEP;self.render(false)});
    this.clear.forEach(function(c){c.addEventListener('click',function(e){e.preventDefault();GROUPS.forEach(function(g){self.sel[g.k]=[]});self.shown=STEP;self.render(true)})});
    root.addEventListener('change',function(e){
      var i=e.target;if(!i.matches('[data-g]'))return;
      var arr=self.sel[i.getAttribute('data-g')],val=i.value,ix=arr.indexOf(val);
      if(i.checked&&ix<0)arr.push(val);if(!i.checked&&ix>-1)arr.splice(ix,1);
      self.shown=STEP;self.render(true);
    });
    root.addEventListener('click',function(e){
      var b=e.target.closest('[data-g-more]');if(b){self.open[b.getAttribute('data-g-more')]=!self.open[b.getAttribute('data-g-more')];self.renderFacets();return}
      var c=e.target.closest('[data-chip]');if(c){e.preventDefault();var g=c.getAttribute('data-chip'),v=c.getAttribute('data-v'),arr=self.sel[g],ix=arr.indexOf(v);if(ix>-1)arr.splice(ix,1);self.shown=STEP;self.render(true)}
    });
    root.classList.add('is-live');
    this.render(false);
  }
  List.prototype.match=function(it,skip){
    for(var i=0;i<GROUPS.length;i++){var g=GROUPS[i];if(g.k===skip)continue;var s=this.sel[g.k];if(!s.length)continue;
      var vals=g.get(it),ok=false;for(var j=0;j<vals.length;j++)if(s.indexOf(vals[j])>-1){ok=true;break}if(!ok)return false}
    return true;
  };
  List.prototype.renderFacets=function(){
    var self=this,html='';
    GROUPS.forEach(function(g){
      var counts={};
      self.all.forEach(function(it){if(!self.match(it,g.k))return;g.get(it).forEach(function(v){counts[v]=(counts[v]||0)+1})});
      self.sel[g.k].forEach(function(v){if(!(v in counts))counts[v]=0});
      var vals=Object.keys(counts);if(vals.length<2&&!self.sel[g.k].length)return;
      vals.sort(g.order==='desc'?function(a,b){return b.localeCompare(a)}:function(a,b){return counts[b]-counts[a]||a.localeCompare(b)});
      var sel=self.sel[g.k],openAll=self.open[g.k],rows='',hidden=0;
      vals.forEach(function(v,ix){
        var on=sel.indexOf(v)>-1,hide=!openAll&&ix>=SHOW&&!on;if(hide){hidden++;return}
        rows+='<label class="opt'+(on?' is-on':'')+'"><input type="checkbox" data-g="'+g.k+'" value="'+esc(v)+'"'+(on?' checked':'')+(counts[v]===0&&!on?' disabled':'')+'><span>'+esc(v)+'</span><small>'+counts[v]+'</small></label>';
      });
      var btn=vals.length>SHOW?'<button type="button" class="mb-showmore" data-g-more="'+g.k+'">'+(openAll?'Show less':'Show '+hidden+' more')+'</button>':'';
      html+='<details open><summary>'+g.label+(sel.length?' <em>'+sel.length+'</em>':'')+'</summary><div class="opts">'+rows+'</div>'+btn+'</details>';
    });
    this.facets.innerHTML=html||'<p class="mb-nofacets">Nothing to narrow down here.</p>';
  };
  List.prototype.results=function(){
    var self=this,r=this.all.filter(function(it){return self.match(it,null)});
    var s=this.sort;
    if(s==='price-ascending')r.sort(function(a,b){return a.p-b.p});
    else if(s==='price-descending')r.sort(function(a,b){return b.p-a.p});
    else if(s==='title-ascending')r.sort(function(a,b){return a.t.localeCompare(b.t)});
    else if(s==='created-descending')r.sort(function(a,b){return b.cr-a.cr});
    else if(s==='year-descending')r.sort(function(a,b){return b.yr-a.yr});
    return r;
  };
  List.prototype.render=function(push){
    var self=this,r=this.results();
    this.renderFacets();
    this.count.forEach(function(c){c.textContent=r.length+(r.length===1?' book':' books')});
    var any=GROUPS.some(function(g){return self.sel[g.k].length});
    this.clear.forEach(function(c){c.hidden=!any});
    if(this.chips){var ch='';GROUPS.forEach(function(g){self.sel[g.k].forEach(function(v){ch+='<a href="#" data-chip="'+g.k+'" data-v="'+esc(v)+'" aria-label="Remove '+esc(v)+'">'+esc(v)+' ×</a>'})});this.chips.innerHTML=ch;this.chips.hidden=!ch}
    // the search itself found nothing: show the book finder instead of an empty grid (and no quote prompt)
    var none=this.opt.q!=null&&!this.all.length;
    this.root.classList.toggle('is-none',none);
    this.grid.innerHTML=r.length?r.slice(0,this.shown).map(card).join(''):none?noFind(this.opt.q,this.root.getAttribute('data-wa')):'<div class="mb-empty" style="grid-column:1/-1"><p>No books match these filters.</p></div>';
    if(none)fillPop(this.grid);
    if(this.more){var left=r.length-this.shown;this.more.hidden=left<=0;this.more.textContent='Show '+Math.min(left,STEP)+' more books'}
    if(window.mbPaintWish)window.mbPaintWish(this.grid);
    if(push){
      var u=new URL(location.href);GROUPS.forEach(function(g){u.searchParams.delete(g.k);self.sel[g.k].forEach(function(v){u.searchParams.append(g.k,v)})});
      if(this.sort&&this.sort!==(this.opt.relevance?'relevance':'best-selling'))u.searchParams.set('sort_by',this.sort);else u.searchParams.delete('sort_by');
      u.searchParams.delete('page');history.replaceState(null,'',u.toString());
    }
  };

  // ---------- collection pages ----------
  document.querySelectorAll('[data-mb-list]').forEach(function(root){
    load(root.getAttribute('data-mb-list'),'session').then(function(items){new List(root,items,{})}).catch(function(){});
  });

  // ---------- search page ----------
  // Word search runs in the browser. If the AI address is set, meaning-based matches (typos, plain-English questions)
  // are added after the books that match every word. The AI gets 1.8 seconds; after that the page shows word results only.
  function aiSearch(api,q){
    if(!api||q.length<2)return Promise.resolve([]);
    var call=fetch(api.replace(/\/$/,'')+'/search',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({q:q})})
      .then(function(r){return r.ok?r.json():{hits:[]}}).then(function(j){return j.hits||[]}).catch(function(){return []});
    return Promise.race([call,new Promise(function(res){setTimeout(function(){res([])},1800)})]);
  }
  document.querySelectorAll('[data-mb-search]').forEach(function(root){
    var q=root.getAttribute('data-mb-search')||'';
    Promise.all([load('/collections/all','local'),aiSearch(root.getAttribute('data-ai'),q)]).then(function(res){
      var items=res[0],hits=res[1],r=search(items,q),partial=r.loose||!r.length,note=document.querySelector('[data-mb-loose]');
      if(hits.length){
        var byH={},seen={};items.forEach(function(it){byH[it.h]=it});r.forEach(function(it){seen[it.h]=1});
        var extra=hits.map(function(x){return byH[x.h]}).filter(function(it){return it&&!seen[it.h]});
        // when no book has every word, the meaning matches usually beat the partial word matches
        r=partial?extra.concat(r):r.concat(extra);
        if(note&&partial)note.textContent='No book matched every word, so these are the closest matches.';
      }
      if(note)note.hidden=!(partial&&r.length);
      new List(root,r,{relevance:true,q:q});
    }).catch(function(){});
  });

  // ---------- suggestions under the header search box ----------
  document.querySelectorAll('form.mb-search').forEach(function(f){
    var inp=f.querySelector('input[name=q]'),box=document.createElement('div'),t,cur=-1;
    if(!inp)return;
    box.className='mb-suggest';box.hidden=true;box.setAttribute('role','listbox');f.appendChild(box);
    inp.setAttribute('aria-autocomplete','list');
    function close(){box.hidden=true;cur=-1}
    function show(){
      var q=inp.value.trim();if(q.length<2){close();return}
      load('/collections/all','local').then(function(items){
        if(inp.value.trim()!==q)return;
        var r=search(items,q);
        if(!r.length){box.innerHTML='<div class="mb-suggest__none">No books found for “'+esc(q)+'”. <a href="#find">Ask us to find it</a></div>';box.hidden=false;return}
        box.innerHTML=r.slice(0,6).map(function(it){
          return '<a class="mb-suggest__row" role="option" href="/products/'+it.h+'">'+(it.img?'<img src="'+esc(it.img)+'" alt="" loading="lazy">':'<span class="ph"></span>')+
            '<span class="tx"><b>'+esc(it.t)+'</b><small>'+esc([it.a,it.v].filter(Boolean).join(' · '))+'</small></span><span class="pr">'+money(it.p)+'</span></a>';
        }).join('')+'<button type="submit" class="mb-suggest__all">See all '+r.length+' results for “'+esc(q)+'”</button>';
        box.hidden=false;cur=-1;
      }).catch(close);
    }
    inp.addEventListener('focus',function(){load('/collections/all','local');if(inp.value.trim().length>1)show()});
    inp.addEventListener('input',function(){clearTimeout(t);t=setTimeout(show,120)});
    inp.addEventListener('keydown',function(e){
      var rows=box.querySelectorAll('.mb-suggest__row');if(box.hidden||!rows.length)return;
      if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();var n=rows.length;if(e.key==='ArrowDown'){cur++;if(cur>=n)cur=-1}else{cur--;if(cur<-1)cur=n-1}rows.forEach(function(r,i){r.classList.toggle('is-cur',i===cur)})}
      else if(e.key==='Enter'&&cur>-1){e.preventDefault();location.href=rows[cur].href}
      else if(e.key==='Escape')close();
    });
    document.addEventListener('click',function(e){if(!f.contains(e.target))close()});
  });
})();
